<template><explore v-if="!tableauId && presentation.renewed" /><analysis-workspace v-else :active="!!tableauId && presentation.renewed" :tableau-id="tableauId || ''"><analytics-platform :tableau-id="tableauId" /></analysis-workspace></template>
<script>
import Explore from './Explore.vue';
import AnalyticsPlatform from '../pages/analyticsPlatform.vue';
import AnalysisWorkspace from './AnalysisWorkspace.vue';
import { presentation } from './presentation';
export default { components: { Explore, AnalyticsPlatform, AnalysisWorkspace }, props: { tableauId: { type: String, default: null } }, data: () => ({ presentation }) };
</script>
